import { isUndefined, omitBy, pickBy } from "@s-libs/micro-dash";
import { useRouter as useOriginalRouter } from "next/router";

import getNextJsUrlObject from "./getNextJsUrlObject";
import { STICKY_QUERY_PARAMS } from "./router.contants";

export { default } from "next/router";
export * from "next/router";

const isStickyParam = (_, key) => STICKY_QUERY_PARAMS.includes(key);

export function useRouter() {
  const router = useOriginalRouter();

  const push = (url, ...args) => {
    const urlObject = typeof url === "string" ? getNextJsUrlObject(url) : url;
    const urlQuery = omitBy(urlObject.query, isStickyParam);
    const stickyQuery = pickBy(
      { ...router.query, ...urlObject.query },
      isStickyParam,
    );
    const query = { ...urlQuery, ...omitBy(stickyQuery, isUndefined) };
    return router.push({ ...urlObject, query }, ...args);
  };

  return { ...router, push };
}
